import { FiverrContext } from '@fiverr-private/fiverr_context';

const LEAF_IDS_MAP = {
    BookDesign: 51,
    BetaReading: 347,
    BookAndEBookWriting: 354,
    AudiobookProduction: 391,
    BookTrailers: 400,
    BookAndEBookMarketing: 415,
    BookEditing: 430,
    ChildrensBookIllustration: 536,
    ConvertToAnEBook: 2051,
    BookBlurbs: 2241,
    BookProposals: 2242,
    Ghostwriting: 2240,
    ShortStories: 2293,
    BookCoverDesign: 2318,
    BookLayoutDesignAndTypesetting: 2319,
    KindleNicheResearch: 2348,
    ComicBookIllustration: 3016,
    DevelopmentalEditing: 3037,
    LineEditing: 3041,
};

export const LEAF_IDS = Object.values(LEAF_IDS_MAP);

export const SELLER_COUNTRIES: FiverrContext['countryCode'][] = ['LK', 'KE', 'IN', 'MA', 'NG', 'BD', 'PK', 'ID'];
